// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__28BKN","productName":"Table_productName__255hL"};